import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useLink } from "../../providers/LinkBehaviourContext";
export const LinkBehaviour = forwardRef(({ children, nativeBehaviour, ...props }, ref) => {
    const LinkComponent = useLink();
    if (!LinkComponent || nativeBehaviour) {
        return (_jsx("a", { ref: ref, ...props, children: children }));
    }
    return _jsx(LinkComponent, { ...props, children: children });
});
//# sourceMappingURL=LinkBehaviour.js.map